import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './css/AdminLayout.css';
import ImageWithPlaceholder from '../components/ImageWithPlaceholder';
import Footer from '../components/Footer';

const AdminLayout = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, loading, isAuthenticated, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  // 권한 체크 활성화
  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated()) {
        alert('로그인이 필요합니다.');
        navigate('/');
        return;
      }
      // 사용자 정보가 로드된 후에만 관리자 권한 체크
      if (user && !isAdmin()) {
        alert('관리자 권한이 필요합니다.');
        navigate('/');
        return;
      }
    }
  }, [loading, user, isAuthenticated, isAdmin, navigate]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  // 네비게이션 클릭 핸들러 (디버깅용)
  const handleNavClick = (path, event) => {
    console.log('Navigation clicked:', path);
    event.preventDefault();
    navigate(path);
  };

  // 로딩 중이거나 사용자 정보가 아직 로드되지 않은 경우 로딩 표시
  if (loading || !user) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        로딩 중...
      </div>
    );
  }

  const navLinks = (
    <>
      <NavLink 
        to="/admin/customer" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('회원 관리 클릭');
          setMobileMenuOpen(false);
        }}
      >
        회원 관리
      </NavLink>
      <NavLink 
        to="/admin/category" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('카테고리 관리 클릭');
          setMobileMenuOpen(false);
        }}
      >
        카테고리 관리
      </NavLink>
      <button 
        onClick={(e) => {
          console.log('상품 관리 버튼 클릭');
          e.preventDefault();
          navigate('/admin/products');
          setMobileMenuOpen(false);
        }}
        style={{ 
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          fontSize: '16px',
          padding: '8px 12px',
          borderRadius: '4px'
        }}
      >
        상품 관리
      </button>
      <NavLink 
        to="/admin/quotes" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('견적 관리 클릭');
          setMobileMenuOpen(false);
        }}
      >
        견적 관리
      </NavLink>
      <NavLink 
        to="/admin/stats/connection" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('통계 분석 관리 클릭');
          setMobileMenuOpen(false);
        }}
      >
        통계 분석 관리
      </NavLink>
      <NavLink 
        to="/admin/support" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('고객 지원 클릭');
          setMobileMenuOpen(false);
        }}
      >
        고객 지원
      </NavLink>
      <NavLink 
        to="/admin/design" 
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('디자인 관리 클릭');
          setMobileMenuOpen(false);
        }}
      >
        디자인 관리
      </NavLink>
            <NavLink 
        to="/admin/settings"
        className={({ isActive }) => (isActive ? 'active' : '')} 
        onClick={(e) => {
          console.log('환경 설정 클릭');
          setMobileMenuOpen(false);
        }}
      >
        환경 설정
      </NavLink>
    </>
  );

  return (
    <div className="admin-layout-container">
      <header className="admin-header">
        <div className="logo-container">
          <Link to="/admin">
            <img src="/logo.png" alt="logo" className="logo" />
          </Link>
        </div>
        <nav className="header-nav">
          <span>{user?.name ? `${user.name} 님` : '관리자'}</span>
          <Link to="/">쇼핑몰</Link>
          <span className="logout" onClick={handleLogout}>로그아웃</span>
        </nav>
         <div className="mobile-header-actions">
            <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
            </button>
        </div>
      </header>
      <nav className="main-nav">
        {navLinks}
      </nav>

      {isMobileMenuOpen && <div key="admin-mobile-overlay" className="mobile-menu-overlay" onClick={toggleMobileMenu}></div>}

      <div className={`mobile-side-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <button className="close-menu-btn" onClick={toggleMobileMenu}>X</button>
          {navLinks}
      </div>

      <main className="admin-main-content-wrapper">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AdminLayout; 